import { ConflictError } from './ConflictError';

/** The catalog code — match on it, never on the message or `instanceof`. */
export const MENU_GROUP_BAR_PRICES_STALE = 'MENU_GROUP_BAR_PRICES_STALE' as const;

/** What the menu editor shows when its copy of a menu's modifier groups is out of date. */
export const MENU_GROUP_BAR_PRICES_STALE_MESSAGE =
    "This menu's modifier groups changed while you had it open — reload to keep the newer version.";

/**
 * A menu-group save that would write `modifierGroups` over a newer revision
 * (the bar's per-menu prices, an import, another editor)
 * (design 2026-09-30 B5). The menu editor saves `modifierGroups[]` WHOLESALE,
 * so an editor opened before the bar saved a per-menu price would otherwise
 * delete that price by saving its older copy. `modifierGroupsRev` is the
 * revision the editor loaded; a save whose revision is not the stored one is
 * refused with this (409), and the Firestore rules refuse the same write
 * when it slips past the client's check.
 */
export class MenuGroupModifierGroupsStaleError extends ConflictError {
    public readonly code = MENU_GROUP_BAR_PRICES_STALE;

    constructor(details?: Record<string, unknown>, options?: ErrorOptions) {
        super(MENU_GROUP_BAR_PRICES_STALE_MESSAGE, { code: MENU_GROUP_BAR_PRICES_STALE, ...details }, options);
    }
}
